import { FileOutlined, LoadingOutlined, ReloadOutlined } from '@ant-design/icons';
import { Button, Dropdown, Menu, Popconfirm, Tooltip } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { ViewerPagesNavigation } from '../../../viewer_base/routes';
import { TestProjectDashboardStore } from '../../stores';
import './TestProjectPackageActions.less';

type Props = {
    packageId: string | null;
    packageName: string;
    store: TestProjectDashboardStore;
};

const TestProjectPackageActions: React.FC<Props> = ({ packageId, packageName, store }) => {
    if (!packageId) {
        return null;
    }

    // Check if package is currently being processed (busy)
    const isPackageBusy = store.busyPackages.includes(packageId);

    const downloadMenu = (name: string) => {
        const format = name.split('.').pop() ?? '';
        return (
            <Menu>
                <Menu.Item key="1" onClick={() => store.projectsBaseStore.handleDownload(packageId)}>
                    Download {format.toLocaleLowerCase()}
                </Menu.Item>
                <Menu.Item key="2" onClick={() => store.projectsBaseStore.handleDownload(packageId, 'apkg')}>
                    Download apkg
                </Menu.Item>
            </Menu>
        );
    };

    const href = `${process.env.PUBLIC_URL}${ViewerPagesNavigation.DocumentViewerPage}/${encodeURIComponent(packageId)}?fileName=${encodeURIComponent(packageName)}`;

    return (
        <div className="test-project-package-actions-container" onClick={e => e.stopPropagation()}>
            <Dropdown overlay={() => downloadMenu(packageName)} trigger={['click']}>
                <Tooltip title="Download">
                    <Button type="link" size="small">
                        <i className="alpha-icon lg download-icon" />
                    </Button>
                </Tooltip>
            </Dropdown>

            <Tooltip title="Open Document">
                <Button type="link" size="small" target="_blank" rel="noreferrer" href={href}>
                    <FileOutlined style={{ fontSize: '16px', color: '#9BA0AA' }} />
                </Button>
            </Tooltip>

            <Popconfirm
                title="Are you sure you want to re-parse this document? This will process the document again."
                onConfirm={() => store.reparsePackage(packageId)}
                okText="Yes"
                cancelText="No"
                placement="topLeft"
                disabled={isPackageBusy}
            >
                <Tooltip
                    placement="topLeft"
                    title={isPackageBusy ? 'Document is being processed...' : 'Re-parse document'}
                >
                    <Button type="link" size="small" disabled={isPackageBusy}>
                        {isPackageBusy ? (
                            <LoadingOutlined style={{ fontSize: '16px', color: '#9BA0AA' }} />
                        ) : (
                            <ReloadOutlined style={{ fontSize: '16px', color: '#9BA0AA' }} />
                        )}
                    </Button>
                </Tooltip>
            </Popconfirm>
        </div>
    );
};

export default observer(TestProjectPackageActions);
